import { APPLICATION_BANK_STATUS_KKB } from "../utils/guards/ApplicationBankStatusGuard/types";

export const STATUSES_APPLICATION_BANKS_TO_SIGN_IN = [
  APPLICATION_BANK_STATUS_KKB.SIGNING,
  APPLICATION_BANK_STATUS_KKB.SIGNATURE_REQUIRED,
  APPLICATION_BANK_STATUS_KKB.RESIGNING,
  APPLICATION_BANK_STATUS_KKB.DOCUMENT_SIGNED
];
